import React, { useRef, useState, useEffect } from "react";
import "./index.scss";
import {
  Box,
  Modal,
} from "@mui/material";
import { fetchData } from "../../Actions/911Actions.js";
import ComboBox from "../ComboBox";
import Tooltip from "@mui/material/Tooltip";
import emergencyIcon from "../../assets/images/emergency-icon.svg";
import drillMode from "../../assets/images/911_drillmode.svg"
import testMode from "../../assets/images/911_testmode.svg"
import backbtn from "../../assets/images/backbtn.svg";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import facility from "../../assets/images/facility.svg";
import pushbtn from "../../assets/images/pushbtn.svg";
import cambtn from "../../assets/images/cambtn.svg";
import closeIcon from "../../assets/images/closeicon.svg";
import locationIcon from "../../assets/images/locationIcon.svg";
import cameraActive from "../../assets/images/cameraButtonactiv3.svg";
import PushButton from "../../assets/images/pushButtonactiv3.svg";
import prealrmfottage from "../../assets/images/prealrmfottage.svg";
import nodata from "../../assets/images/nodata.svg";
import { Container, Row, Col } from "react-bootstrap";
import VideoPlayer from "../VideoPlayer";
import { useDispatch, useSelector } from "react-redux";

import LoaderOverlay from "../Overlay";
import Header from "../Header/Header";
import Pagination from "../Pagination";
import {
  Snackbar,
} from "@mui/material";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4, 
  paddingRight: 4,
};
export default function LockdownDashboard() {
  const logoRef = useRef(null);
  const dispatch = useDispatch();
  const { loading: isLoading, data: lockdownInfo } = useSelector((state) => state.nine11);
  const [activeScreen, setActiveScreen] = useState("normal");
  const [isExpired, setIsExpired] = useState(false);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [open, setOpen] = useState(false);
  const [signalsCount, setSignalCount] = useState(lockdownInfo?.signals?.length ?? 0);
  const [showNewSignalTooltip, setShowNewSignalTooltip] = useState(false);
  const [signalIndex, setSignalIndex] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch({type: "HIDE_SIDEBAR"});
    return () => {
      dispatch({type: "SHOW_SIDEBAR"});
    }
  }, [])

  const videosPerPage = 2;
  const allVideos =
    lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto?.flatMap((floor) =>
      floor.cameras.map((cam) => cam.cameraSnippet)
    ) || [];

  const totalPages = Math.ceil(allVideos.length / videosPerPage);
  const startIndex = (page - 1) * videosPerPage;
  const currentVideos = allVideos.slice(startIndex, startIndex + videosPerPage);

  useEffect(() => {
    if (logoRef.current) {
      logoRef.current.focus();
    }
  }, []);
  const initialized = useRef(false);

  useEffect(() => {
    let blueprintTimer;
    let livefeedTimer;

    if (
      activeScreen === "blueprint" &&
      lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto?.length
    ) {
      blueprintTimer = setTimeout(() => {
        document.getElementById("backButtonBlueprint")?.focus();
      }, 1000);
      const firstFloor =
        lockdownInfo.signals[signalIndex].signalBlueprintDto[0].floorName;
      setSelectedFloor(firstFloor);
    }

    if (activeScreen === "livefeed" && lockdownInfo?.liveCameraFeeds?.length) {
      livefeedTimer = setTimeout(() => {
        document.getElementById("liveFeedBackButton")?.focus();
      }, 1000);
      const firstFloor = lockdownInfo.liveCameraFeeds[0].floorName;
      setSelectedFloor(firstFloor);
    }

    // Cleanup timers on dependency change or unmount
    return () => {
      if (blueprintTimer) clearTimeout(blueprintTimer);
      if (livefeedTimer) clearTimeout(livefeedTimer);
    };
  }, [activeScreen, signalIndex]);

  const handleRefreshToLatest = () => { 
    handleClose(); 
    setActiveScreen("normal"); 
    const signals = lockdownInfo?.signals; 
    if (!signals?.length) return; 
    const latestSignal = signals[signals.length -1]; 
    setSignalIndex(signals.indexOf(latestSignal)); 
  };

useEffect(() => {
  const accountId = parseInt(window.location.pathname.split("/")[1]);

  if (accountId) {
    dispatch(fetchData(accountId));

    const intervalId = setInterval(() => {
      dispatch(fetchData(accountId));
    }, 5000);

    // cleanup
    return () => clearInterval(intervalId);
  }
}, [dispatch]);


  useEffect(() => {
    if(lockdownInfo) {
      if(lockdownInfo?.flag === "false") {
        setIsExpired(true);
        initialized.current = false;
        setShowNewSignalTooltip(false);
      } else if(lockdownInfo?.signals) {
        setIsExpired(false);
        if (!initialized.current) {
          setSelectedFloor(lockdownInfo?.signals[lockdownInfo?.signals?.length - 1].signalBlueprintDto[0].floorName);
          setSignalIndex(lockdownInfo?.signals?.length - 1);
          setSignalCount(lockdownInfo?.signals?.length);
          initialized.current = true;
        }
      }
    }
  }, [lockdownInfo])

      const isFirstRender = useRef(true);

    useEffect(() => {
      if(lockdownInfo?.signals) {
        if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
        }

        if (
          lockdownInfo?.signals?.length > signalsCount &&
          signalIndex !== lockdownInfo?.signals.length - 1
        ) {
          setOpen(true);
        }
        setSignalCount(lockdownInfo?.signals?.length || 0);
      }
    }, [lockdownInfo?.signals?.length]);

  const [selectedFloor, setSelectedFloor] = useState( );

  const handleCameraClick = (cameraName) => {
    let camera = null;

    if (activeScreen === "blueprint") {
      const currentFloor = lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto?.find(
        (floor) => floor.floorName === selectedFloor
      );
      camera = currentFloor?.cameras?.find(
        (cam) => cam.cameraName === cameraName
      );
      if(!camera) {
        camera = currentFloor.pushButtonCameraDtos.filter((ele) => ele.pushButtonName === cameraName);
      }
    } else if (activeScreen === "livefeed") {
      const currentFloor = lockdownInfo?.liveCameraFeeds.find(
        (floor) => floor.floorName === selectedFloor
      );
      camera = currentFloor?.cameraLiveFeed?.find(
        (cam) => cam.cameraName === cameraName
      );
    }

    if (camera) {
      setSelectedCamera(camera);
      setOpenCameraModal(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const firstInputRef = useRef(null);

  useEffect(() => {
    if (openCameraModal) {
      const timer = setTimeout(() => {
        if (firstInputRef.current) {
          firstInputRef.current.focus();
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [openCameraModal]);


  useEffect(() => {
    if(lockdownInfo?.signals) setSelectedFloor(lockdownInfo?.signals[signalIndex].location);
  }, [signalIndex]);

  useEffect(() => {
    if (lockdownInfo?.signals?.length > signalsCount && signalIndex !== lockdownInfo?.signals.length - 1) {
      setShowNewSignalTooltip(true);
    }
    setSignalCount(lockdownInfo?.signals?.length || 0);
  }, [lockdownInfo?.signals?.length]);


  useEffect(() => {
    const timer = setTimeout(() => {
          document.getElementsByClassName("logo-class")[0]?.focus();
      }, 300);
      return () => clearTimeout(timer);
  }, [])


  return (
    <>
      <Header diffClass="nineoneheader" showRest={false} />
      {isLoading ? (
        <LoaderOverlay />
      ) : isExpired ? (
        <div className="error-container">
          <img className="error-image" src={nodata} alt="" aria-hidden="true" />
          <h1>No Active Lockdown</h1>
          <p>
            At present, everything is normal and there is no active lockdown.
            This page does not contain any lockdown information right now. If an
            alarm is triggered in this building, this page will immediately
            update to show all necessary details, including the nature of the
            alarm, affected areas, and real-time updates.
          </p>
          <p><strong>Building Address:</strong> {lockdownInfo?.buildingAddress}</p>
        </div>
      ) : (
        <>
        {openCameraModal && selectedCamera && (
          <Modal
            open={openCameraModal && selectedCamera}
            aria-labelledby="add-edit-building-title"
            aria-modal="true"
            onClose={(event, reason) => {
              if (reason === "escapeKeyDown") {
                if (tooltipOpen) {
                  setTooltipOpen(false);
                } else {
                  setOpenCameraModal(false);
                }
              } else if (reason === "backdropClick") {
                return;
              }
            }}
            className={`globalForm`}
          >
            <div role="none">
              <Box
                role="dialog"
                aria-modal="true"
                sx={style}
                aria-labelledby="camera-feed"
                className="mainModalBox"
              >
                <div
                  className="Modal_header"
                >
                  <h1 id="camera-feed">
                    {selectedCamera.cameraName}
                  </h1>
                  <AccessibleTooltip title="Close" open={tooltipOpen} customclass={"modalcloseTooltip"}>
                    <button
                      ref={firstInputRef}
                      onClick={() => setOpenCameraModal(false)}
                      className={"close_button_modal"}
                      aria-label="Close"
                      onFocus={() => setTooltipOpen(true)}
                      onBlur={() => setTooltipOpen(false)}
                      onMouseEnter={() => setTooltipOpen(true)}
                      onMouseLeave={() => setTooltipOpen(false)}
                    >
                      <img src={closeIcon} alt="" aria-hidden="true" />
                    </button>
                  </AccessibleTooltip>
                </div>
      
                <div className="Modal_middle" id="add-edit-user-description" style={{ backgroundColor: "#000"}}>
                    {activeScreen === "blueprint" ? (
                      <video
                        src={selectedCamera.cameraSnippet}
                        controls
                        style={{ width: "100%", borderRadius: "8px", marginTop: "8px" }}
                        aria-label={`Recorded video from ${selectedCamera.cameraName}`}
                      />
                    ) : (
                      <VideoPlayer
                        url={selectedCamera.cameraFeed}
                        cameraName={selectedCamera.cameraName}
                      />
                    )}
                </div>
              </Box>
            </div>
          </Modal>
        )}
         <main role="main" className="lockdown-dashboard middle_container_911">
          {activeScreen === "blueprint" && (
            <>
              <div aria-live="polite" className="sr-only">
                {showNewSignalTooltip && "New pushbutton pressed — click to refresh"}
              </div>

              <div className="innerFeedWrapper">
                  <AccessibleTooltip title={"Back"}>
                    <button data-testid="backButtonBlueprint" id="backButtonBlueprint" onClick={() => setActiveScreen("normal")}><img src={backbtn} alt=""  /></button>
                  </AccessibleTooltip>
                <h1>
                    Blueprint
                  </h1>
              </div>

              <p className="innerTxtheading">
                Where alarm activated and all nearby cameras that captured video before
                activation.
              </p>
              <span style={{ border: '1px solid #747474', display: 'block', height: '1px', marginTop:'24px' }}></span>
              <div
              className="cameradetailsTxt"
              >
                <p className="innerTxtheading">
                  Click on any camera to see a full-screen view of the{" "}
                  <strong>{lockdownInfo?.videoSnippetDurationInSeconds} seconds prior</strong> to activation.
                </p>

                <div style={{ maxWidth: "250px" }}>
                  <ComboBox
                    label="Select Floor"
                    options={lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto?.map(
                      (floor) => floor.floorName || `Floor ${floor.floorId}`
                    )}
                    value={
                      selectedFloor ||
                      lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto[0]?.floorName
                    }
                    onChange={(selectedValue) => setSelectedFloor(selectedValue)}
                  />
                </div>
              </div>
                  <div className="wrapperOver">
                         <div
               className="mapImgWrapper"
              >
                {lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto
                  ?.filter(
                    (floor) =>
                      floor.floorName === selectedFloor ||
                      (!selectedFloor &&
                        floor.floorId ===
                          lockdownInfo?.signals?.[signalIndex]?.signalBlueprintDto?.[0]?.floorId)
                  )
                  .map((blueprintFloor) => (
                    <React.Fragment key={blueprintFloor.floorId}>
                      {blueprintFloor?.cameras
  ?.filter((cam) => {
    const pushButtonIds =
      blueprintFloor?.pushButtonCameraDtos?.map((ele) => ele.pushButtonId) || [];
    return !pushButtonIds.includes(cam.cameraId);
  })
  ?.map((cam) => (
    <Tooltip
      key={cam.cameraId}
      title={cam.cameraName}
      arrow
      placement="top"
    >
      <button
        className="camera-overlay-button"
        style={{
          position: "absolute",
          top: `${cam.ycoordinate}%`,
          left: `${cam.xcoordinate}%`,
          transform: "translate(-50%, -50%)",
          cursor: "pointer",
          border: "none",
          background: "transparent",
        }}
        onClick={() => handleCameraClick(cam.cameraName)}
        aria-label={`Camera ${cam.cameraName}`}
        data-testid={cam.cameraName}
      >
        <img src={cameraActive} alt="" className="camera-img" />
      </button>
    </Tooltip>
))}


                      {blueprintFloor?.pushButtonCameraDtos.map((ele) => (
                            <div style={{
                              position: 'absolute',
                              top: `${ele.ycoordinate}%`,
                              left: `${ele.xcoordinate}%`,
                            }}>
                            {ele.cameraSnippet && <Tooltip
                          // key={cam.cameraId}
                          title={ele.pushButtonName}
                          arrow
                          placement="top"
                        >
                          <button
                            className="camera-overlay-button"
                            style={{
                              position: "absolute",
                              paddingLeft: '87px',
                              transform: "translate(-50%, -50%)",
                              cursor: "pointer",
                              border: "none",
                              background: "transparent",
                            }}
                            onClick={() => handleCameraClick(ele.pushButtonName)}
                            aria-label={`Camera ${ele.pushButtonName}`}
                            data-testid={ele.pushButtonName}
                          >
                            <img
                              src={cameraActive}
                              alt=""
                              className="camera-img"
                            />
                          </button>
                        </Tooltip>}
                        {blueprintFloor.pushbuttonYcoor && blueprintFloor.pushbuttonXcoor && blueprintFloor.pushbuttonXcoor === ele.xcoordinate && blueprintFloor.pushbuttonYcoor === ele.ycoordinate && <Tooltip
                            title={ele.pushButtonName}
                            arrow
                            placement="top"
                          >
                            <button
                              className="camera-overlay-button"
                              style={{
                                position: "absolute",
                                // top: `${blueprintFloor.pushbuttonYcoor}%`,
                                // left: `${blueprintFloor.pushbuttonXcoor - 4.5}%`,
                                transform: "translate(-50%, -50%)",
                                cursor: "default",
                                border: "none",
                                background: "transparent",
                              }}
                              aria-label={`Pushbutton ${ele.pushButtonName}`}
                            >
                              <img
                                src={PushButton}
                                alt="Pushbutton"
                                className="camera-img"
                              />
                            </button>
                          </Tooltip>}
                            </div>
                        ))}
                          {blueprintFloor?.pushbuttonYcoor && blueprintFloor?.pushbuttonXcoor && <Tooltip
                            title={lockdownInfo?.signals?.[signalIndex]?.pushbutton}
                            arrow
                            placement="top"
                          >
                            <button
                              className="camera-overlay-button"
                              style={{
                                position: "absolute",
                                top: `${blueprintFloor?.pushbuttonYcoor}%`,
                                left: `${blueprintFloor?.pushbuttonXcoor}%`,
                                transform: "translate(-50%, -50%)",
                                cursor: "default",
                                border: "none",
                                background: "transparent",
                              }}
                              aria-label={`Pushbutton ${lockdownInfo?.signals?.[signalIndex]?.pushbutton}`}
                            >
                              <img
                                src={PushButton}
                                alt="Pushbutton"
                                className="camera-img"
                              />
                            </button>
                          </Tooltip>}

                      <div className="floorimgwrapper">
                         <img
                          alt={`Interactive building blueprint showing security devices`}

                          src={blueprintFloor.blueprint}
                          className="floorMapImg"
                          style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                          }}
                        />
                      </div>
                    </React.Fragment>
                  ))}
              </div>
                  </div>
                 <div className="deviceTypeFotter">
                      <ul>
                         <li><img src={pushbtn} alt="" aria-hidden />Red Button shows where alarm activated</li>
                         <li><img src={cambtn} alt="" aria-hidden />Blue cameras show nearby cameras that recorded {lockdownInfo?.videoSnippetDurationInSeconds} seconds before activation</li>
                      </ul>
                  </div>
            </>
          )}
          {activeScreen === "livefeed" && (
            <>
              <div aria-live="polite" className="sr-only">
                {showNewSignalTooltip && "New pushbutton pressed — click to refresh"}
              </div>
              <div className="innerFeedWrapper">
                  <AccessibleTooltip title={"Back"}>
                    <button data-testid="liveFeedBackButton" id="liveFeedBackButton" onClick={() => setActiveScreen("normal")}><img src={backbtn} alt=""  /></button>
                  </AccessibleTooltip>
                 <h1>
                  Live Feed
                </h1>
              </div>
              <span style={{ border: '1px solid #747474', display: 'block', height: '1px', marginTop:'24px' }}></span>
              <div
                className="cameradetailsTxt"
              >
                <p className="innerTxtheading">
                  Click on any camera to see its Live Feed (<strong>~ 2-5 second delay</strong>)
                </p>

                <div style={{maxWidth: "250px" }}>
                  <ComboBox
                    label="Select Floor"
                    options={lockdownInfo?.liveCameraFeeds?.map(
                      (floor) => floor.floorName || `Floor ${floor.floorId}`
                    )}
                    value={
                      selectedFloor ||
                      lockdownInfo?.liveCameraFeeds?.[0]?.floorName
                    }
                    onChange={(selectedValue) => setSelectedFloor(selectedValue)}
                  />
                </div>
              </div>

                <div className="wrapperOver">
                     <div
                className="mapImgWrapper"
              >
                {lockdownInfo?.liveCameraFeeds
                  ?.filter(
                    (floor) =>
                      floor.floorName === selectedFloor ||
                      (!selectedFloor &&
                        floor.floorId === lockdownInfo?.liveCameraFeeds?.[0]?.floorId)
                  )
                  ?.map((liveCamera) => (
                    <React.Fragment key={liveCamera.floorId}>
                      {liveCamera.cameraLiveFeed?.map((cam, index) => (
                        <Tooltip
                          key={cam.cameraName}
                          title={cam.cameraName}
                          arrow
                          placement="top"
                        >
                          <button
                            className="camera-overlay-button"
                            style={{
                              position: "absolute",
                              top: `${cam.ycoordinate}%`,
                              left: `${cam.xcoordinate}%`,
                              transform: "translate(-50%, -50%)",
                              cursor: "pointer",
                              border: "none",
                              background: "transparent",
                            }}
                            onClick={() => handleCameraClick(cam.cameraName)}
                            aria-label={`Camera ${cam.cameraName}`}
                            data-testid={cam.cameraName}
                          >
                            <img
                              src={cameraActive}
                              alt={`Camera ${index + 1}`}
                              className="camera-img"
                            />
                          </button>
                        </Tooltip>
                      ))}
                      <div className="floorimgwrapper">
                      <img
                        alt={liveCamera.floorName}
                        src={liveCamera.floorMap}
                        className="floorMapImg"
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "white",
                        }}
                      />
                      </div>
                    </React.Fragment>
                  ))}
              </div>

                </div>
                 <div className="deviceTypeFotter">
                      <ul>
                         <li><img src={pushbtn} alt="" aria-hidden />Red Button shows where alarm activated</li>
                      </ul>
                  </div>
            </>
          )}
          {activeScreen === "normal" && 
          <>
          <div aria-live="polite" className="sr-only">
            {showNewSignalTooltip && "New pushbutton pressed — click to refresh"}
          </div>
          {lockdownInfo?.signalType === "Lockdown" && <div className="alert-box">
            <h1><img src={emergencyIcon} alt="" />EMERGENCY LOCKDOWN ACTIVE</h1>
          </div>}
          {lockdownInfo?.signalType === "Drill Mode" && <div className="drill-box">
            <h1><img src={drillMode} alt="" style={{ marginRight: '10px' }}/>DRILL MODE ACTIVE</h1>
            <p>This is a simulated emergency. No action or Police dispatch is required.</p>
          </div>}
          {lockdownInfo?.signalType === "Test Mode" && <div className="drill-box">
            <h1><img src={testMode} alt="" style={{ marginRight: '10px' }}/>TEST MODE ACTIVE</h1>
            <p>System testing in progress. No action or Police dispatch is required.</p>
          </div>}
          {lockdownInfo?.signals?.length > 1 && (
            <div className="pushbtnCombo">
              <h3>See Previous Alarm Presses</h3>
              <ComboBox
                label="Press Button"
                options={[
                  ...(lockdownInfo?.signals?.map((signal) => {
                    const eventTime = new Date(parseInt(signal.eventTime)).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    });
                    return `${signal.pushbutton} (${eventTime})`;
                  }) || []),
                ]}
                value={(() => {
                  const sig = lockdownInfo?.signals?.[signalIndex];
                  if (!sig) return "";

                  const t = new Date(parseInt(sig.eventTime)).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  });
                  return `${sig.pushbutton} (${t})`;
                })()}
                onChange={(val) => {
                  const match = val.match(/^(.+?) \((.+?)\)$/);
                  if (match) {
                    const name = match[1];
                    const timeStr = match[2];

                    const selectedIndex = lockdownInfo?.signals?.findIndex((sig) => {
                      const eventTimeFormatted = new Date(parseInt(sig.eventTime)).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      });
                      return sig.pushbutton === name && eventTimeFormatted === timeStr;
                    });

                    if (selectedIndex !== -1) {
                      setSignalIndex(selectedIndex);
                    }
                  }
                }}
              />
            </div>
          )}
          <div className="mainBox">
            <Container fluid>
              <Row>
                <Col md={6} xl={6}>
                  <div className="camera-card">
                    {/* <div className="card-header">
                      <h2>Critical Alert</h2>
                      <span className=" active_floor_g"><img src={activeSVG} alt="" /> Active</span>
                    </div> */}
                    {/* <p className="lcdprototext">Lockdown protocol activated</p> */}
                    {/* <span style={{ border: '1px solid #E6E6E6', display: 'block', height: '1px' }} /> */}
                    <div className="building-info">
                      <h3 className="facility-heading"><img src={facility} alt="" aria-hidden />Send Police</h3>
                      <p className="facility-building-address">There is a Lockdown Alarm at:</p>
                      <h3 className="facility-building-name">{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex]?.buildingAddress?.split(",")?.[0] : ""}</h3>
                      <p className="facility-building-address">{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex]?.buildingAddress?.split(",")?.[1] : ""}, {lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex]?.buildingAddress?.split(",")?.[2] : ""}</p>
                      {/* <p className="facility-building-address">{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex].buildingAddress.split(",")[2] : ""}</p> */}
                    </div>
                    <div className="building-info">
                      <h3 className="facility-heading">
                       <img src={locationIcon} alt="" aria-hidden />
                          Alarm Activated
                      </h3>

                      <p className="facilityAlmdetails">
                        <span>Name :</span> <span>{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex].pushbutton : ""}</span>
                      </p>

                      <p className="facilityAlmdetails">
                        <span>Floor :</span> <span>{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex].location : ""}</span>
                      </p>

                      <p className="facilityAlmdetails">
                        <span>NIMS :</span> <span>{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex]?.zoneName?.split(",")?.[0] : ""}</span>
                      </p>

                      <p className="facilityAlmdetails">
                        <span>Nearest Exit :</span> <span>{lockdownInfo?.signals ? lockdownInfo?.signals[signalIndex]?.zoneName?.split(",")?.[1] : ""}</span>
                      </p>

                      <p className="facilityAlmdetails">
                        <span>Time :</span> <span>{lockdownInfo?.signals ? new Date(parseInt( lockdownInfo?.signals[signalIndex].eventTime))?.toLocaleTimeString("en-IN",{hour12:true,hour:"2-digit",minute:"2-digit",second:"2-digit"}) : ""}</span>
                      </p>
                    </div>
                    <div className="feedButtons" role="list">
                      <div role="listitem">
                        <p>Click for live camera feed (~2-5 sec delay)</p>
                        <button data-testid="live-feed" onClick={() => {
                          setActiveScreen("livefeed");
                        }}>Live Feed (~2-5 sec delay)</button>
                      </div>
                        <span className="diveder"></span>
                        <div role="listitem">
                          <p>Click for alarm location map and captured footage before activation</p>
                        <button onClick={() => {
                          setActiveScreen("blueprint");
                        }}>Blueprint</button>
                        </div>
                    </div>
                  </div>
                </Col>
                <Col md={6} xl={6}>
                  <div className="blueprint-card">

                    <div className="recording-info"> 
                      <div className="bluprintDetail">
                        <h3 className="container-heading" id="heading-title">
                        <img alt="" src={prealrmfottage} aria-hidden />
                          Pre-Alarm Footage
                        </h3>
                        <span className=" active_floor_g">{selectedFloor}</span>
                      </div>
                      {/* <img src={recrdInfor} alt="" aria-hidden />  */}
                      The videos below show {lockdownInfo?.videoSnippetDurationInSeconds} seconds before the alarm was activated near the button that was used to activate the alarm.
                    </div>
                    {/* <div className="rcrdTab">
                         <h3>Recorded Video Snippet</h3>
                    </div> */}
                 
                    {allVideos?.length > 0 && (
                      <div
                        className="videowrapper"
                      >
                        {currentVideos.map((videoUrl, index) => (
                          <div className="videoPlaerBox" key={index}>
                            <video
                              src={videoUrl}
                              controls
                              autoPlay
                              loop
                              muted
                              controlsList="nodownload noremoteplayback noplaybackrate"
                              width="300"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    <div>
                      <Pagination
                        page={page}
                        totalPages={totalPages}
                        totalItems={allVideos.length}
                        itemsPerPage={videosPerPage}
                        onPageChange={setPage}
                      />
                    </div>
                </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="footerBox">
              <div className="footertext"><p>Support Team Lockdown Experts</p></div>
              <p className="copyrightText">2024 © Lockdownexperts. All Right reserved</p>
          </div>
          </>}
        </main>
        <Snackbar
          open={open}
          className={"error"}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          message={<>New Pushbutton is triggered right now. To view the latest information <button className="link-btn" onClick={handleRefreshToLatest}>click here</button>.</>}
        />
        </>
      )}
    </>
  );
}